var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKonfigurimet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.63 14.58A7.927 7.927 0 0 0 22 12c0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8c1.3 0 2.52-.31 3.58-.85l3.81 3.81a.5.5 0 0 0 .71 0l1.41-1.41a.5.5 0 0 0 0-.71zM4 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6zm9-2h-2V8h2v2zm-5 0H6V8h2v2zm0-3H6V5h2v2zm5 0h-2V5h2v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKonfigurimet);
export default __webpack_public_path__ + "static/media/icon_konfigurimet.b50ca39448c58e1b43662d53a88479a6.svg";
export { ForwardRef as ReactComponent };